<template>
 <div>
     <Header />
    <b-container class="card bg-white my-5 pb-5 pt-2 px-4">
        <div class="mt-2 text-left text-primary">
            <h4 class="text-green pt-4">{{$t('new_member_registration')}}</h4>
            <hr>
        </div>
        <b-form @submit.prevent="submitMember">
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <span class="same-as-hkid">{{$t('same_as_hkid')}}</span>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('english_first_name')}}</b></h6>
                </b-col>
                <b-col md="7" cols="12">
                    <b-input placeholder="Tai Man" v-model="member.firstName" required class="roundeds"></b-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('english_last_name')}}</b></h6>
                </b-col>
                <b-col md="7" cols="12">
                    <b-input placeholder="Chan" v-model="member.lastName" required class="roundeds"></b-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('chinese_first_name')}}</b></h6>
                </b-col>
                <b-col md="7" cols="12">
                    <b-input placeholder="大文" v-model="member.chineseFirstName" required class="roundeds"></b-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('chinese_last_name')}}</b></h6>
                </b-col>
                <b-col md="7" cols="12">
                    <b-input placeholder="陳" v-model="member.chineseLastName" required class="roundeds"></b-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('mobile_phone_no')}}</b></h6>
                </b-col>
                <b-col md="4" cols="12">
                    <b-input :placeholder="$t('mobile_phone_no')" v-model="member.phone" required disabled class="roundeds"></b-input>
                </b-col>
                <b-col md="3" cols="12">
                    <b-input-group>
                        <template #append>
                            <b-button size="sm" variant="success" class="roundeds ml-1" @click="getVerCode">{{$t('get_code')}}</b-button>
                        </template>
                        <b-input :placeholder="$t('verify_phone')" v-model="member.verCode" class="roundeds"></b-input>
                    </b-input-group>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('email')}}</b></h6>
                </b-col>
                <b-col md="7" cols="12">
                    <b-input :placeholder="$t('email')" v-model="member.email" class="roundeds"></b-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('id_card')}}</b></h6>
                </b-col>
                <b-col md="7" cols="12">
                    <b-input placeholder="e.g z813xxx(3)" v-model="member.idCard" required class="roundeds"></b-input>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col md="3" class="text-left" cols="12">
                    <h6><b>{{$t('licenses')}}</b></h6>
                </b-col>
                <b-col md="12" cols="12" class="text-left">
                    <b-row v-for="(license, index) in member.licenses" :key="index">
                        <b-col cols="4">
                            <b-form-group>
                                <label for="license_name" v-if="member.licenses.length && index == 0"><strong>{{$t('select_existing_license')}}</strong></label>
                                <b-form-select class="roundeds" @change="setLicenseValue($event, index)">
                                    <b-form-select-option :value="null">-- {{$t('select')}} --</b-form-select-option>
                                    <b-form-select-option v-for="license in getAllLicenses" :key="license.id" :value="license">{{license.name}}</b-form-select-option>
                                </b-form-select>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group>
                                <label for="expiry_date" v-if="member.licenses.length && index == 0"><strong>{{ $t('expiry_date') }}</strong></label>
                                <b-form-datepicker class="roundeds" :locale="$i18n.locale" v-model="license.expiry"></b-form-datepicker>
                            </b-form-group>
                        </b-col>
                        <b-col cols="3">
                            <b-form-group>
                                <label for="expiry_date" v-if="member.licenses.length && index == 0"><strong>{{ $t('certification_date') }}</strong></label>
                                <b-form-datepicker class="roundeds" v-if="member.licenses[index].hasCertDate" :locale="$i18n.locale" v-model="license.dateOfCert"></b-form-datepicker>
                            </b-form-group>
                        </b-col>
                        <b-col cols="2" align-self="center">
                            <b-button variant="danger" size="sm" pill v-if="index == member.licenses.length-1" @click="addLicense"><i class="fa fa-plus"></i></b-button>
                            <b-button variant="warning" size="sm" class="ml-1" @click="removeLicense(index)" pill v-if="member.licenses.length > 1"><i class="fa fa-minus"></i></b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div class="text-md-left mt-4">
                <b-button pill variant="success" class="d-block pr62" type="submit" :disabled="loading">{{loading ? $t('registering_member') : $t('register_member') }}</b-button>
                <b-button pill variant="outline-secondary" @click="$router.push('/')" :disabled="loading" class="d-block mt-md-2 mt-2 pr-5 pl-5">{{ $t('cancel') }}</b-button>
            </div>
        </b-form>
    </b-container>

        
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Header from '@/components/Header'
export default {
  name: "NewMember",
  components: {
      Header
  },
  computed: {
    ...mapGetters(['getAllLicenses'])
  },
  created() {
    if(!this.getAllLicenses.length) {
        this.$store.dispatch('fetchLicenses')
    }
    this.redirectUser();
    this.member.phone = this.$route.params.phone
  },
  methods: {
    ...mapActions(["createIndividualMember", "getVerificationCode"]),
    setLicenseValue(license, index) {
        this.member.licenses[index].id = license.id
        this.member.licenses[index].name = license.name
        this.$set(this.member.licenses[index], 'hasCertDate', license.hasCertDate);

        console.log(this.member.licenses)
    },
    addLicense() {
        const license = {
            id: null,
            name: null,
            expiry: null,
            dateOfCert: null,
            hasCertDate: null,
        };
        this.member.licenses.push(license);
    },
    removeLicense(index) {
        this.member.licenses.splice(index, 1);
    },
    async getVerCode() {
        const waitingMins = 3;
        const now = new Date();
        if (this.verCodeAvailableTime) {
            const remainMin = (this.verCodeAvailableTime - now) / 60 / 1000;
            if (remainMin > 0) {
                this.toast({title: "Get Verification Code", message: `Please try again after ${Math.ceil(remainMin)} minute(s)`, type: "danger"});
                return;
            }

        }
        const payload = {phone: this.member.phone};
        this.loading = true
        const resp = await this.getVerificationCode(payload)
        this.loading = false
        if(resp == 1) {
            this.verCodeAvailableTime = now;
            this.verCodeAvailableTime.setMinutes(this.verCodeAvailableTime.getMinutes() + waitingMins);
            this.toast({title: "Get Verification Code", message: "Verification code sent to your mobile.", type: "success"})
        }

    },
    async submitMember() {
        let memberData = Object.assign({}, this.member)
        if(this.member.licenses.length == 1 && (this.member.licenses[0].name == null || this.member.licenses[0].name == "")) {
            delete memberData.licenses
        }
        if(!memberData.email) {
            delete memberData.email
        }
        if(memberData.licenses && memberData.licenses.length) {
            let emptyLicense = memberData.licenses.filter(l => !l.name || !l.expiry)
            if(emptyLicense && emptyLicense.length) {
                this.toast({title: "Create Member", message: "License and Expiry for all Licenses is Required.", type: "warning"})
                return
            }
        }

        let isRepeating = false

        if(memberData.licenses && memberData.licenses.length) {
            let licenseRecord = null
            memberData.licenses.forEach(license => {
                if(licenseRecord) {
                    isRepeating = false
                    if(licenseRecord.id === license.id) {
                        isRepeating = true
                        this.toast({title: "Create Member", message: "License cannot be repeated.", type: "warning"})
                        return
                    }
                }
                licenseRecord = Object.assign({}, license)
            })
        }

        if(!isRepeating) {
            this.loading = true
            const resp = await this.createIndividualMember(memberData)
            this.loading = false
            if(resp == 1) {
                var user = {phone: this.member.phone}
                const resp = await this.$store.dispatch('loginMember', user)
                if(resp === 1) {
                    this.move('/booking')
                }
                else {
                    this.$router.push('/member-login')
                }
            }
        }
    }
  },
  data() {
    return {
        today: new Date(),
        loading: false,
        verCodeAvailableTime: null,
        member: {
            firstName: null,
            lastName: null,
            chineseFirstName: null,
            chineseLastName: null,
            email: null,
            phone: null,
            idCard: null,
            licenses: [
                {
                    id: null,
                    name: null,
                    expiry: null,
                    dateOfCert: null
                }
            ]
        },
    }
  }
}
</script>

<style>
.pr62{
    padding-right:62px !important;
    padding-left:62px !important;
}
.same-as-hkid {
    font-size: 12px;
    color: red;
}
</style>